import { getLanguageFromLocale } from '@/utils/i18n'

const APEX_FONT_BY_LANG = {
  ar: 'IBM Plex Sans Arabic, sans-serif',
  en: 'Plus Jakarta Sans, sans-serif',
}

export function getApexChartFontFamily(locale) {
  const lang = getLanguageFromLocale(locale)
  return APEX_FONT_BY_LANG[lang] ?? APEX_FONT_BY_LANG.en
}

export function applyApexChartDefaults(locale) {
  window.Apex = {
    ...window.Apex,
    chart: {
      ...window.Apex?.chart,
      fontFamily: getApexChartFontFamily(locale),
    },
  }
}
